import { useAnalyticsTrack } from '@/features/amplitude'
import { UserDocument } from '../../lib/userDocuments.slice'
import { Button, Dialog } from '@/ui'

interface DialogTriggerProps {
  document: UserDocument
  onClick?: () => void
}

export const DialogTrigger = ({ document, onClick }: DialogTriggerProps) => {
  const track = useAnalyticsTrack()

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation()

    track('clicked document upload', {
      document_category: document.documentType || '',
      document_subcategory: document.userDocumentCategoryId || '',
    })

    if (onClick) {
      onClick()
    }
  }

  return (
    <Dialog.Trigger asChild>
      <Button variant="secondary" onClick={handleClick}>
        Delete File
      </Button>
    </Dialog.Trigger>
  )
}
